import { useEffect, useState, useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";

import "preline/preline";
import { IStaticMethod } from "preline/preline";
import Announcement from "./components/Announcement";
import Hero from "./components/Hero";
import Nav from "./components/Nav";
import Sections from "./components/Sections";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";

if (!window.HSStaticMethods) {
  window.HSStaticMethods = IStaticMethod;
}

function App() {
  const location = useLocation();
  const defaultConfig = useMemo(() => ({
    title_head: "保険証の情報",
    title_tail: "の確認方法",
    show_announcement: true,
    show_oldcard: true,
    show_maina: true,
    show_newcard: true,
    show_notification: true,
    show_faq: true,
    show_hero_catch: true,
    show_hero_lead: true,
    show_section_title: true,
    show_footer: true,
  }), []);
  const simpleConfig = useMemo(() => ({
    title_head: "保険証の情報",
    title_tail: "の確認方法",
    show_announcement: true,
    show_oldcard: true,
    show_maina: true,
    show_newcard: true,
    show_notification: true,
    show_faq: false,
    show_hero_catch: false,
    show_hero_lead: true,
    show_section_title: true,
    show_footer: true,
  }), []);
  const [config, setConfig] = useState(defaultConfig);

  useEffect(() => {
    window.HSStaticMethods.autoInit();
  }, [location.pathname]);

  const updateConfigBasedOnHash = useCallback((hash) => {
    if (hash === "resonac") {
      setConfig({
        ...simpleConfig,
        title_head: "保険者番号",
        show_notification: false,
      });
    } else if (hash === "full") {
      setConfig(defaultConfig);
    } else {
      setConfig(simpleConfig);
    }
  }, [defaultConfig, simpleConfig]);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace("#", "");
      updateConfigBasedOnHash(hash);
    };

    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [updateConfigBasedOnHash]);


  return (
    <div className="App">
      {config.show_announcement && <Announcement />}
      <header className="App-header">
        <Hero config={config} />
        <Nav config={config} />
      </header>
      <Sections config={config} />
      {config.show_faq && <FaqSection />}
      {config.show_footer && <Footer />}
    </div>
  );
}

export default App;
